import axios from 'axios';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface deleteCropFavoriteParams {
  searchParam: {
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
  };
}

export const deleteCropFavorite = ({ searchParam }: deleteCropFavoriteParams) => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  // return axios.delete(`http://localhost:3002/mock/crops/favorite?${URLSearchParams}`);
  return customAxios.delete(`/crops/favorites?${URLSearchParams}`);
};
